import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const BillingPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Billing,
  }))
);

export function BillingContainer() {
  return <LazyLoadComponent Component={<BillingPage />} />;
}
